import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles/App.css";
import LandingPage from "./LandingPage";
import Imprint from "./Imprint";
import PrivacyPolicy from "./PrivacyPolicy";
import Navbar from "./components/Navbar";

function App() {
  return (
    <Router>
      

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
